import { graphql, useStaticQuery } from "gatsby";

export const useCollection = () => {
  const { allCollections } = useStaticQuery(graphql`
    query COLLECTION {
      allCollections: allSanityCollection {
        edges {
          node {
            shopify {
              id: shopifyId
              handle: shopifyHandle
            }
            gender
            title
            hideSizeFilter
          }
        }
      }
    }
  `);

  return {
    allCollections,
  };
};
